<script lang="ts">
</script>

<div class="loading-indicator">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>

<style lang="scss">
  @use "@astlai/common/styles/mixins" as lib;
  .loading-indicator {
    @include lib.flex-row();
    @include lib.flex-align();
    gap: 0.25rem;
    padding: 0.5rem;
    .dot {
      width: 8px;
      height: 8px;
      background-color: var(--text-tertiary);
      border-radius: 50%;
      animation: pulse 1.5s infinite ease-in-out;
    }

    .dot:nth-child(2) {
      animation-delay: 0.3s;
    }

    .dot:nth-child(3) {
      animation-delay: 0.6s;
    }
    @keyframes pulse {
      0%,
      100% {
        opacity: 0.4;
        transform: scale(0.8);
      }
      50% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
</style>
